// extracted by mini-css-extract-plugin
module.exports = {"todo":"TaskTodo_todo__1M45u","checkbox":"TaskTodo_checkbox__pIXp9","text":"TaskTodo_text__1AVHB"};